<label for="no_autofill_password" class="hidden">No autofill password</label>
<input
  id="no_autofill_password"
  type="text"
  name="password"
  class="hidden"
  tabindex="-1"
/>
<label for="no_autofill_confirm_password" class="hidden">
  No autofill confirm password
</label>
<input
  id="no_autofill_confirm_password"
  type="text"
  name="confirmPassword"
  class="hidden"
  tabindex="-1"
/>
<div
  class="fields__item fields__item_full"
  [appIfInvalid]="passwordFC"
  [validationErrors]="{
    required: 'Please, enter the password!',
    minlength: 'The password is too short. At least 8 characters are required!',
    maxlength: 'The password is too long!',
    hasUppercaseLetterValidator:
      'The password must contain at least one uppercase letter (A..Z)!',
    hasLowercaseLetterValidator:
      'The password must contain at least one lowercase letter (a..z)!',
    hasNumberValidator: 'The password must contain at least one number (0..9)!',
  }"
>
  <input
    [formControl]="passwordFC"
    type="password"
    [placeholder]="passwordLabel"
    maxlength="30"
    autocomplete="password"
    id="password"
  />
  <label for="password">Password</label>
  <ng-template [appErrorsHost] />
</div>

<div
  class="fields__item fields__item_full"
  [appIfInvalid]="confirmPasswordFC"
  [validationErrors]="{
    required: 'Please, confirm the password!',
    equalTo: 'The passwords do not match!',
  }"
>
  <input
    [formControl]="confirmPasswordFC"
    type="password"
    [placeholder]="confirmPasswordLabel"
    maxlength="30"
    autocomplete="confirmPassword"
    id="confirm_password"
  />
  <label for="confirm_password">Repeat password</label>
  <ng-template [appErrorsHost] />
</div>
